<template>
	<section class="main-content intro">
		<div class="row">
			<slot>
				<div class="columns column12 align-center">
					<slot name="preheader-content" />
					<div class="reverse-heading">
						<h1>{{ title }}</h1>
						<h2 class="subtitle">{{ subtitle }}</h2>
					</div>
					<slot name="extra-heading" />
					<div v-parse-links v-html="content" />
					<slot name="extra-content" />
					<div class="bottom-block" />
				</div>
			</slot>
		</div>
	</section>
</template>

<script setup>
defineProps({
	title: { type: String, default: '' },
	subtitle: { type: String, default: '' },
	content: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.intro {
	padding-bottom: 0;

	.row {
		max-width: 980px;
	}
}

.bottom-block {
	background: var(--dark-background-color);
	width: 60px;
	height: 12px;
	margin: 75px auto 0;
}

.no-block {
	.bottom-block {
		height: 0;
	}
}

.reverse-heading {
	margin: 0 0 10px;

	.subtitle {
		margin: 0 0 10px;
	}
}
</style>
